import React, {useState} from "react";
import {useForm} from "react-hook-form";
// import AdminFields from "./AdminFields";
import EditProfileFields from "./EditProfileFields";

export default function () {
  const {register, handleSubmit, reset, control} = useForm();
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  // const adminFields = <AdminFields {...{register, errors}} />;
  const editProfileFields = <EditProfileFields {...{register, errors, control, data}} />;

  return {
    setErrors,
    // adminFields,
    editProfileFields,
    handleSubmit,
    setData,
    reset,
  }
}